// extracted by mini-css-extract-plugin
export default {"wrapper":"FT_xzHm51TCDR4Ksxs9J","rtl":"zjayFjDGPHzfZfKRppTf","modalText":"PTjepftmx_WjAr1M5yr0","loadingWrapper":"gV2KsooVlvrVFC3h1nxg"};